<template>
  <i-select :value="value" :clearable="true" @input="input">
    <i-option
      v-for="(item, key) in types"
      :key="key"
      :value="item"
      :label="$t(`pbx.stat.common.field.${item}`)"
    />
  </i-select>
</template>

<script>
  const types = ['incoming', 'outgoing'];
  export default {
    props: {
      value: {
        type: String,
        default: '',
        validator: function(value) {
          if (value) {
            return types.indexOf(value) !== -1;
          }
          return true;
        }
      }
    },
    data: () => ({ types: types }),
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
